import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'
import { faCloudDownloadAlt } from '@fortawesome/pro-regular-svg-icons/faCloudDownloadAlt'

import { Helmet } from 'react-helmet'
import axios from 'axios'
import download from 'downloadjs'
import { useSettings } from '@peracto/peracto-hooks'
import { Heading, Group, Form, Select } from '@peracto/peracto-ui'
import { useConfig } from '@peracto/peracto-config'
import startCase from 'lodash/startCase'
import { DEFAULT_LOCATION_TYPES } from '../../util'

const LocationExport = () => {
    const config = useConfig()
    const API_URL = config.get('api')

    const { values } = useSettings()
    const location_types = values?.location_types

    const locationTypes =
        location_types?.length > 0
            ? location_types.map(type => {
                  return {
                      label: startCase(type.replace(/_/g, ' ')),
                      value: type,
                  }
              })
            : DEFAULT_LOCATION_TYPES

    // Prevent enter key submitting form
    function onKeyDown(keyEvent) {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            keyEvent.preventDefault()
        }
    }

    const handleSubmit = async (type, values) => {
        const filteredValues = {}

        for (const [field, value] of Object.entries(values)) {
            if (!!value) {
                filteredValues[field] = value
            }
        }

        let filename = `${type}.csv?${new URLSearchParams(filteredValues).toString()}`

        const { data } = await axios.get(`${API_URL}/export/${filename}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })

        const filenameDetails = Object.values(filteredValues).join('_')

        download(data, `${type}_export${filenameDetails ? `_${filenameDetails}` : ''}.csv`)
    }

    return (
        <>
            <Helmet>
                <title>Export Location Data | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Export Location Data">
                    <div className="!flex !items-center !ml-2">
                        <Link className="btn btn-outline-primary" to="/locations">
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                            Back to Locations
                        </Link>
                    </div>
                </Heading>

                <div className="row">
                    <div className="col-12 col-lg-6">
                        <Group key="location" id="location" name="Locations">
                            <Form
                                values={{
                                    type: '',
                                }}
                                showActionPanel={false}
                                onSubmit={values => handleSubmit('location', values)}
                                onKeyDown={onKeyDown}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <Select
                                            name="type"
                                            label="Location Type"
                                            options={[
                                                { label: 'All', value: '' },
                                                ...locationTypes,
                                            ]}
                                        />

                                        <button
                                            className="btn btn-outline-primary"
                                            type="submit"
                                            data-testid="export-locations"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCloudDownloadAlt}
                                                className="!mr-2"
                                            />
                                            Export Locations
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </Group>
                    </div>

                    <div className="col-12 col-lg-6">
                        <Group key="location_types" id="location_types" name="Location Types">
                            <Form
                                values={{}}
                                showActionPanel={false}
                                onSubmit={values => handleSubmit('location_type', values)}
                                onKeyDown={onKeyDown}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-outline-primary"
                                            type="submit"
                                            data-testid="export-location-types"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCloudDownloadAlt}
                                                className="!mr-2"
                                            />
                                            Export Location Types
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </Group>
                    </div>

                    <div className="col-12 col-lg-6">
                        <Group
                            key="location_features"
                            id="location_features"
                            name="Location Features"
                        >
                            <Form
                                values={{}}
                                showActionPanel={false}
                                onSubmit={values => handleSubmit('location_feature', values)}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-outline-primary"
                                            type="submit"
                                            data-testid="export-location-features"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCloudDownloadAlt}
                                                className="!mr-2"
                                            />
                                            Export Location Features
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </Group>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LocationExport
